/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestResultDto } from '../../models/contents-request-result-dto';
import { CreateContentsRequestResultDto } from '../../models/create-contents-request-result-dto';

export interface ContentsRequestResultControllerCreate$Params {
  contentsRequestId: string;
      body: CreateContentsRequestResultDto
}

export function contentsRequestResultControllerCreate(http: HttpClient, rootUrl: string, params: ContentsRequestResultControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestResultDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestResultControllerCreate.PATH, 'post');
  if (params) {
    rb.path('contentsRequestId', params.contentsRequestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestResultDto>;
    })
  );
}

contentsRequestResultControllerCreate.PATH = '/api/contents-request-result/{contentsRequestId}';
